/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_LowInputs */

const en_us2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below the range`)
};

const pt_br2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abaixo da faixa`)
};

const es_419_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por debajo del rango`)
};

const pt_pt2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abaixo do intervalo`)
};

const fr_fr2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous la fourchette`)
};

const de_de2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter dem Bereich`)
};

const it_it2_body_assessment_whtr_band_low = /** @type {(inputs: Body_Assessment_Whtr_Band_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sotto l'intervallo`)
};

/**
* | output |
* | --- |
* | "Below the range" |
*
* @param {Body_Assessment_Whtr_Band_LowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_low = /** @type {((inputs?: Body_Assessment_Whtr_Band_LowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_LowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_low(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_low(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_low(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_low(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_low(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_low(inputs)
	return en_us2_body_assessment_whtr_band_low(inputs)
});
export { body_assessment_whtr_band_low as "body-assessment.whtr_band.low" }